import { DateTime } from "luxon";

export const toISODate = date => {
  // return date.toISOString().substring(0, 10);
  // return date.format("yyyy-MM-dd");
  return DateTime.fromJSDate(date).toISODate();
};

export const sortObject = (obj = {}) => {
  return Object.keys(obj)
    .sort()
    .reduce(
    (_sortedObj, key) => ({
      ..._sortedObj,
      [key]: obj[key]
    }),
    {}
    );
};

export const isoDatesBetween = (_start, _stop) => {
  if (!(_start instanceof Date)) _start = new Date(_start)
  if (!(_stop instanceof Date)) _stop = new Date(_stop)

  let [start, stop] = [DateTime.fromJSDate(_start), DateTime.fromJSDate(_stop)].sort()
  const dates = [];
  while (start <= stop) {
    dates.push(start.toISODate());
    start = start.plus({ days: 1 })
  }
  return dates;
}


// WEBPACK FOOTER //
// ./src/helpers.js